
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import type { RatingStatModel } from '@alao-frontend/erp-services'
import RatingBar from '~/components/sections/rating/RatingBar.vue'

type RatingServiceKey = keyof Pick<
  RatingStatModel,
  | 'internet'
  | 'mobile'
  | 'tv'
  | 'time_to_install_score'
  | 'customer_service_score'
  | 'user_experience_score'
  | 'correct_invoices_score'
>;

const servicesList: RatingServiceKey[] = [
  'internet',
  'mobile',
  'tv',
  'time_to_install_score',
  'customer_service_score',
  'user_experience_score',
  'correct_invoices_score',
]

@Component({
  components: {
    RatingBar,
  },
})
export default class RatingServices extends Vue {
  @Prop({ required: true })
  readonly providerScores!: RatingStatModel

  get services () {
    return servicesList.map((service) => {
      const translationKey = `provider.rating.service.${service}`

      return {
        label: this.$t(translationKey),
        score: this.providerScores[service] || 0,
      }
    })
  }
}
